import React from 'react'
import cx from 'classnames'

import { Box } from 'components/layout/Box/Box'

import { TooltipHandlersContext, TooltipPropsContext } from '../../context'

import styles from './Anchor.module.scss'

export const Anchor = ({
  ariaLabeledBy = 'tooltip-anchor',
  children,
  className = undefined,
  onClick,
  isDisabled,
}) => {
  const { reference } = React.useContext(TooltipPropsContext)
  const {
    onBlur,
    onFocus,
    onMouseEnter,
    onMouseLeave,
    onTouchStart,
    onTouchEnd,
  } = React.useContext(TooltipHandlersContext)

  return (
    // TODO: when the implementation of the Button component will be
    // finalized it probably should incorporate the component itself
    <button
      aria-labelledby={ariaLabeledBy}
      className={cx(styles.button, { [className]: Boolean(className) })}
      ref={reference}
      type="button"
      disabled={isDisabled}
      {...{
        onBlur,
        onClick,
        onFocus,
        onMouseEnter,
        onMouseLeave,
        onTouchStart,
        onTouchEnd,
      }}
    >
      <Box
        align="center"
        className={styles.content}
        justify="center"
        tagName="span"
      >
        {children}
      </Box>
    </button>
  )
}
